import {
  ICloudAnalysisResponse,
  IMostVisitedArchPayload,
  IMostVisitedArchResponse,
  IMostVisitedSectionPayload,
  IMostVisitedSectionResponse,
  IVisitedPagePayload,
} from '../../store/actions/WebAnalytics/TrafficAnalyticsActions';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.ANALYTICS;

export class TrafficAnalyticsService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(serviceType, ServerType.dcaBackend);

  public getMostVisitedMenu(
    payload: IMostVisitedSectionPayload,
  ): Promise<IMostVisitedSectionResponse[]> | IMostVisitedSectionResponse[] {
    const route: string[] = [API_ROUTE.PAGE];
    return this.dcaBackendService.get({
      route: route,
      query: { startDate: payload.startDate },
    });
  }
  public getMostVisitedArch(
    payload: IMostVisitedArchPayload,
  ): Promise<IMostVisitedArchResponse[]> | IMostVisitedArchResponse[] {
    const route: string[] = [API_ROUTE.ARCHITECTURE.BASE];
    return this.dcaBackendService.get({
      route: route,
      query: { architectureType: payload.architectureType },
    });
  }
  public getMostVisitedCloudAssessment():
    | Promise<IMostVisitedArchResponse[]>
    | IMostVisitedArchResponse[] {
    const route: string[] = [API_ROUTE.CLOUD.ASSESSMENT];
    return this.dcaBackendService.get({
      route: route,
    });
  }
  public postVisitedMenu(payload: IVisitedPagePayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.PAGE];
    return this.dcaBackendService.post({ route: route }, payload);
  }
  public getCloudProviderAnalytics(): Promise<ICloudAnalysisResponse[]> | ICloudAnalysisResponse[] {
    const route: string[] = [API_ROUTE.CLOUD.BASE];
    return this.dcaBackendService.get({ route: route });
  }
}

const trafficAnalyticsService = new TrafficAnalyticsService();
export default trafficAnalyticsService;
